const fetchClientConfig = async (): Promise<Partial<IClientConfig>> => {

    const browserLocale = navigator.languages ? navigator.languages[0] : navigator.language;
    
    const response = await fetch('/api/client/config');
    if (!response.ok) {
        console.error(new Error('An error occured while fetching client config: ' + response.statusText));
        return { lang: browserLocale };
    }

    const config = await response.json();
    return {
        ...config,
        lang: config.lang && config.lang !== '' ? config.lang : browserLocale
    };
}

const documentReady = async () => {
    return new Promise(function (resolve) {
        // in case the document is already rendered
        if (document.readyState !== 'loading') resolve(void 0);
        // modern browsers
        else if (document.addEventListener) document.addEventListener('DOMContentLoaded', () => resolve(void 0));

    });
}

export const fetchConfig = async() => {
    await documentReady()
    return await fetchClientConfig();
}

export interface IClientConfig {
    stripeToken: string,
    intercomAppId: string,
    gifProvider: string,
    lang: string
}